<template>
    <div class="secondLevelPage">
        <img src="@/assets/img/secondLevelPage/mingcaiBg.jpg" class="mingcaiBg hml_whplt" v-if="firstLevelIndex == 1">
        <div class="publicTop">
            <div class="homeBut" @click="homeButClick">
                <img src="@/assets/img/secondLevelPage/home.gif" alt="">
            </div>
            <div class="swiper-container navBox">
                <ul class="swiper-wrapper">
                    <li
                    v-for="(item,index) in allData[firstLevelIndex].dataArr"
                    :key="index"
                    :class="['swiper-slide',
                    {active: secondLevelIndex == index},
                    allData[firstLevelIndex].dataArr.length>4&&firstLevelIndex!=3?'slide1':'slide2']"
                    @click="navClick(item)"
                    >
                        <span>{{ item.title }}</span>
                        <!-- <div class="xian" v-if="index == 0" :style="{left: xianLeftNum}"></div> -->
                    </li>
                </ul>
            </div>
            <div :class="['mapBut',{mapBut1: (this.firstLevelIndex == 3 && this.secondLevelIndex == 3) || (this.firstLevelIndex == 3 && this.secondLevelIndex == 4)}]" @click="mapButClick" v-if="firstLevelIndex > 1">
                <img src="@/assets/img/secondLevelPage/mapButton.png" alt="">
            </div>
        </div>
        <div class="router">
            <transition name="routerViewAnimation1">
                <router-view></router-view>
            </transition>
        </div>
        <transition name="PlayAroundDetails">
            <PlayAroundDetails v-if="playAroundDetailsFlag"></PlayAroundDetails>
        </transition>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
let audioState = createNamespacedHelpers("audioState");
import Swiper from "swiper";
import 'swiper/css/swiper.css';
import PlayAroundDetails from '@/components/PlayAround/PlayAroundDetails';
export default {
    data() { 
        return {
            xianLeftNum: '50%',
            swiper: null,
        }
    },
    created(){
        console.log(this.secondLevelIndex);
        if(!this.auidoStateArr[0]){
            setTimeout(() => {
                document.getElementById("music").pause();
            },200);
            
        }
         // console.log(this.secondLevelIndex);
        // 当从详情返回时计算出导航底部线的位置
        if(this.secondLevelIndex != 0){
            let num = this.allData[this.firstLevelIndex].dataArr.length > 4 && this.firstLevelIndex != 3? 137 : 100;
            this.xianLeftNum = (this.secondLevelIndex * num + 50) + "%";
        }
    },
    mounted(){
        
        if(this.mapJumpListFlag){
            // this.setMapJumpListFlag(false);
            this.navClick(this.secondLevelIndex);
        }
        if(this.allData[this.firstLevelIndex].dataArr.length > 4 && this.firstLevelIndex != 3){
            // playAroundDetailsFlag
            this.swiper = new Swiper('.navBox',{
                slidesPerView: 'auto',
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
            });
            if(this.secondLevelIndex > 2){
                this.swiper.slideTo(this.secondLevelIndex,100,false);
            }
        }
        
    },
    methods: {
        mapButClick(){
            if((this.firstLevelIndex == 3 && this.secondLevelIndex == 3) || (this.firstLevelIndex == 3 && this.secondLevelIndex == 4)){
                return;
            }
            this.setGetIntoTheState(1);
            this.$router.push("/map");
        },
        homeButClick(){
            this.$router.push({name: 'index'});
        },
        navClick(item){
            if(this.secondLevelIndex == item.secondLevelIndex){
                return;
            }
            this.setSwiperNum(0);
            this.setShoppingFlag(false);
            if(this.allData[this.firstLevelIndex].dataArr.length > 4 && this.firstLevelIndex != 3){
                if((item.secondLevelIndex == 1 && this.swiper.translate != 0) || ((item.secondLevelIndex == 2 || item.secondLevelIndex == 3) && this.swiper.translate == 0)){
                    this.swiper.slideTo(this.swiper.translate == 0?item.secondLevelIndex : 0,100,false);
                }
            }
            if(this.mapJumpListFlag){
                this.setIndex({secondLevelIndex: item.secondLevelIndex});
            }else{
                this.setIndex({secondLevelIndex: item.secondLevelIndex,levelThreeIndex: 0});
            }
            
            let num = this.allData[this.firstLevelIndex].dataArr.length > 4 && this.firstLevelIndex != 3? 137 : 100;
            this.xianLeftNum = (item.secondLevelIndex * num + 50) + "%";
            let routerName = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].routerName;
            this.$router.push({name: routerName});
             // console.log(this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].routerName);
        },
        ...publicData.mapMutations(["setIndex","setGetIntoTheState","setSwiperNum","setMapJumpListFlag","setShoppingFlag"])
    },
    computed: {
        ...audioState.mapState(["auidoStateArr"]),
        ...publicData.mapState(["allData","firstLevelIndex","secondLevelIndex","playAroundDetailsFlag","mapJumpListFlag","mapJumpListFlag"])
    },
    components: {
        PlayAroundDetails
    }
}
</script>

<style lang="scss" scoped>
.secondLevelPage{
    width: 100%;
    height: 100%;
    // background: #0cf;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    .router{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        // padding-top: 1rem;
    }
    .publicTop{
        width: 100%;
        height: .92rem;
        background: #fff;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99;
        border-radius:0px 0px .2rem .2rem;
        box-shadow:0px .07rem .06rem 0px rgba(0, 0, 0, 0.09);
        overflow: hidden;
        .navBox{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            padding-left: 1rem;
            padding-right: .84rem;
            overflow: hidden;
        }
        ul{
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            li{
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                white-space: nowrap;
                font-size: .32rem;
                color: rgba(51,51,51,.5);
                position: relative;
                span{
                    padding: .1rem .18rem;
                    transition: all .2s ease;
                }
                &.slide1{
                    width: auto;
                    // margin-right: 3%;
                    &:last-of-type{
                        margin-right: .2rem;
                    }
                }
                &.slide2{
                    flex: 1;
                }
                .xian{
                    width: .6rem;
                    height: .08rem;
                    background:linear-gradient(0deg,rgba(88,191,167,1) 0%,rgba(112,219,202,1) 100%);
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 0;
                    transition: all .2s ease;
                }
                &.active{
                    span{
                        color: #fff;
                        background: #44B89E;
                        border-radius: .28rem;
                    }
                    
                }
            }
        }
        .homeBut{
            width: .7rem;
            height: .7rem;
            background: #fff;
            position: absolute;
            left: 0;
            top: 0;
            padding: .14rem .24rem .08rem;
            padding-right: 0;
            box-sizing: content-box;
            z-index: 10;
        }
        .mapBut{
            width: .64rem;
            height: .54rem;
            background: #fff;
            position: absolute;
            right: 0;
            top: 0;
            padding: .15rem .1rem .23rem;
            padding-right: .24rem;
            box-sizing: content-box;
            z-index: 10;
            &.mapBut1{
                opacity: 0.5;
            }
            .img{
                width: 100%;
                height: 100%;
                background-repeat: no-repeat;
                background-position: -.5rem 0rem;
                background-size: 2rem 1.1rem;
            }
        }
    }
}
.routerViewAnimation1-enter{
	opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.routerViewAnimation1-enter-active{
	transition: all .3s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.routerViewAnimation1-enter-to{
	opacity: 1;
}
.PlayAroundDetails-enter,.PlayAroundDetails-leave-to {
	left: 100%;
    opacity: 0;
}
// 控制元素显示过程中实现的具体动画效果
.PlayAroundDetails-enter-active,.PlayAroundDetails-leave-active {
	transition: all .2s ease;
}
// 控制元素完全显示之后的状态(样式、位移信息)
.PlayAroundDetails-enter-to,.PlayAroundDetails-leave {
	left: 0;
    opacity: 1;
}
</style>